const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "http://127.0.0.1:8000").replace(/\/$/, "");

/** Resolve API-stored avatar path to a full URL for <img src>. */
export function resolveAvatarUrl(avatarUrl) {
    if (!avatarUrl || typeof avatarUrl !== "string") return null;
    if (avatarUrl.startsWith("http://") || avatarUrl.startsWith("https://")) return avatarUrl;
    if (avatarUrl.startsWith("/")) return `${BACKEND_URL}${avatarUrl}`;
    return `${BACKEND_URL}/${avatarUrl}`;
}
